module.exports = __webpack_public_path__ + "img/view-top.ec9ca769.png";